export interface MatchPart {
  text: string;
  match: boolean;
}

/**
 * Splits `text` into the parts that match `query` and the parts that don't,
 * ignoring case, so the matches can be highlighted.
 */
export function splitByMatch(text: string, query: string): MatchPart[] {
  const needle = query.trim().toLowerCase();
  if (!needle) {
    return [{ text, match: false }];
  }

  const haystack = text.toLowerCase();
  const parts: MatchPart[] = [];
  let cursor = 0;
  let index = haystack.indexOf(needle);

  while (index !== -1) {
    if (index > cursor) {
      parts.push({ text: text.slice(cursor, index), match: false });
    }
    parts.push({ text: text.slice(index, index + needle.length), match: true });
    cursor = index + needle.length;
    index = haystack.indexOf(needle, cursor);
  }

  if (cursor < text.length) {
    parts.push({ text: text.slice(cursor), match: false });
  }

  return parts;
}
